export const iconSize = { width: '1rem', height: '1rem' };
export const actionButtonStyle = {
  width: '1.75rem',
  height: '1.75rem',
};
export const actionButtonsEnable = {
  edit: '#006AF5',
  add: '#4CAF50',
  delete: '#DA1E28',
};
export const actionButtonsDisable = {
  edit: '#CACACA',
  add: '#CACACA',
  delete: '#CACACA',
};
